import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/ajax-loader-white.gif'


const _withScopeId = n => (_pushScopeId("data-v-2fb74328"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "col-lg-auto col-md-auto col-sm-auto col-xs-12 card bg-blue card-width" }
const _hoisted_2 = { class: "card-body p-0" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item-tertiary-title text-white p-4 pt-2 pb-0 m-2 mb-2 ms-0" }, " Premium payments details ", -1))
const _hoisted_4 = { class: "item-body text-white px-4 py-2 mb-0" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "spinner-icon pb-2",
  src: _imports_0,
  alt: "Loading..."
}, null, -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { class: "d-inline-block w-100 pb-2" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item-tertiary-title text-white" }, "Pro-rata payment", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Amount", -1))
const _hoisted_14 = { class: "float-end" }
const _hoisted_15 = { class: "smaller-text-sub" }
const _hoisted_16 = { class: "d-inline-block w-100 pb-2" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Pro-rata payment due", -1))
const _hoisted_18 = { class: "float-end" }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { key: 1 }
const _hoisted_21 = { class: "d-inline-block w-100 pb-2" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "One off pro-rata payment", -1))
const _hoisted_23 = { class: "float-end" }
const _hoisted_24 = { class: "d-inline-block w-100 pb-2" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Pro-rata payment due", -1))
const _hoisted_26 = { class: "float-end" }
const _hoisted_27 = { key: 0 }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "hr mt-2" }, null, -1))
const _hoisted_29 = { key: 1 }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item-tertiary-title text-white" }, "Regular payment", -1))
const _hoisted_31 = { class: "d-inline-block w-100 pb-2" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Amount", -1))
const _hoisted_33 = { class: "float-end" }
const _hoisted_34 = { class: "smaller-text-sub" }
const _hoisted_35 = { class: "d-inline-block w-100 pb-2" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Frequency", -1))
const _hoisted_37 = { class: "float-end" }
const _hoisted_38 = { class: "d-inline-block w-100 pb-2" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "First payment due", -1))
const _hoisted_40 = { class: "float-end" }
const _hoisted_41 = { key: 0 }
const _hoisted_42 = { key: 2 }
const _hoisted_43 = { class: "d-inline-block w-100 pb-2" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Payments", -1))
const _hoisted_45 = { class: "float-end" }
const _hoisted_46 = { class: "d-inline-block w-100 pb-2" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Frequency", -1))
const _hoisted_48 = { class: "float-end" }
const _hoisted_49 = { class: "d-inline-block w-100 pb-2" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "First payment due", -1))
const _hoisted_51 = { class: "float-end" }
const _hoisted_52 = { key: 0 }
const _hoisted_53 = { key: 0 }
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "hr-light-white mb-1 mt-0" }, null, -1))
const _hoisted_55 = { class: "item-body-small text-white px-4 py-2 mb-0" }
const _hoisted_56 = { key: 0 }
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Note:", -1))
const _hoisted_58 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        (_ctx.isLoading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7))
          : (_openBlock(), _createElementBlock("div", _hoisted_8, [
              (_ctx.hasProRata)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    (_ctx.hasExistingProRata)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                          _createElementVNode("div", _hoisted_11, [
                            _hoisted_12,
                            _hoisted_13,
                            _createElementVNode("span", _hoisted_14, "$" + _toDisplayString(_ctx.formatToTwoDecimalPlace(_ctx.proRata + _ctx.existingProRata)), 1),
                            _createElementVNode("div", _hoisted_15, " Includes $" + _toDisplayString(_ctx.formatToTwoDecimalPlace(_ctx.proRata)) + " for new policy + $" + _toDisplayString(_ctx.formatToTwoDecimalPlace(_ctx.existingProRata)) + " from existing policy ", 1)
                          ]),
                          _createElementVNode("div", _hoisted_16, [
                            _hoisted_17,
                            _createElementVNode("span", _hoisted_18, [
                              _createTextVNode(_toDisplayString(_ctx.formatDateString(_ctx.firstPremiumDate)) + " ", 1),
                              (_ctx.calledFrom === 'DDConfirmation')
                                ? (_openBlock(), _createElementBlock("span", _hoisted_19, "*"))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_20, [
                          _createElementVNode("div", _hoisted_21, [
                            _hoisted_22,
                            _createElementVNode("span", _hoisted_23, "$" + _toDisplayString(_ctx.formatToTwoDecimalPlace(_ctx.proRata)), 1)
                          ]),
                          _createElementVNode("div", _hoisted_24, [
                            _hoisted_25,
                            _createElementVNode("span", _hoisted_26, [
                              _createTextVNode(_toDisplayString(_ctx.formatDateString(_ctx.firstPremiumDate)) + " ", 1),
                              (_ctx.calledFrom === 'DDConfirmation')
                                ? (_openBlock(), _createElementBlock("span", _hoisted_27, "*"))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ])),
                    _hoisted_28
                  ]))
                : _createCommentVNode("", true),
              (_ctx.hasExistingPaymentAmount)
                ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                    _hoisted_30,
                    _createElementVNode("div", _hoisted_31, [
                      _hoisted_32,
                      _createElementVNode("span", _hoisted_33, "$" + _toDisplayString(_ctx.formatToTwoDecimalPlace(_ctx.paymentAmount)), 1),
                      _createElementVNode("div", _hoisted_34, " Includes $" + _toDisplayString(_ctx.formatToTwoDecimalPlace(_ctx.paymentAmount - _ctx.existingPaymentAmount)) + " for new policy + $" + _toDisplayString(_ctx.formatToTwoDecimalPlace(_ctx.existingPaymentAmount)) + " from existing policy ", 1)
                    ]),
                    _createElementVNode("div", _hoisted_35, [
                      _hoisted_36,
                      _createElementVNode("span", _hoisted_37, _toDisplayString(_ctx.formattedFrequency), 1)
                    ]),
                    _createElementVNode("div", _hoisted_38, [
                      _hoisted_39,
                      _createElementVNode("span", _hoisted_40, [
                        _createTextVNode(_toDisplayString(_ctx.formatDateString(_ctx.nextPremiumDate)) + " ", 1),
                        (_ctx.calledFrom === 'DDConfirmation')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_41, "*"))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_42, [
                    _createElementVNode("div", _hoisted_43, [
                      _hoisted_44,
                      _createElementVNode("span", _hoisted_45, "$" + _toDisplayString(_ctx.formatToTwoDecimalPlace(_ctx.paymentAmount)), 1)
                    ]),
                    _createElementVNode("div", _hoisted_46, [
                      _hoisted_47,
                      _createElementVNode("span", _hoisted_48, _toDisplayString(_ctx.formattedFrequency), 1)
                    ]),
                    _createElementVNode("div", _hoisted_49, [
                      _hoisted_50,
                      _createElementVNode("span", _hoisted_51, [
                        _createTextVNode(_toDisplayString(_ctx.formatDateString(_ctx.nextPremiumDate)) + " ", 1),
                        (_ctx.calledFrom === 'DDConfirmation')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_52, "*"))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ]))
            ]))
      ]),
      (_ctx.isNextPaymentDateAfterRenewalDate || _ctx.calledFrom === 'DDConfirmation')
        ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
            _hoisted_54,
            _createElementVNode("div", _hoisted_55, [
              (_ctx.isNextPaymentDateAfterRenewalDate)
                ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                    _hoisted_57,
                    _createTextVNode(" As your next payment date is after your policy renewal date, the above ongoing premiums are at your new rate. ")
                  ]))
                : _createCommentVNode("", true),
              (_ctx.calledFrom === 'DDConfirmation')
                ? (_openBlock(), _createElementBlock("div", _hoisted_58, " *If the DD is authorised after the dates above have passed, the payment will be processed either on the same day or next day after the authorisation was provided. "))
                : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}